import React from 'react';
import { formatDate, formatLastEditTime } from './CashupUtils';

/**
 * Component for displaying a single cashup row
 * @param {Object} props - Component props
 * @param {Object} props.cashup - Cashup data object
 * @param {Function} props.navigateToCashupDetail - Function to navigate to cashup detail
 */
const CashupTableRow = ({ cashup, navigateToCashupDetail }) => {
  return (
    <tr className="cashup-table-row">
      <td>
        {cashup.status === 1 ? (
          <span className="status-badge status-complete">Complete</span>
        ) : (
          <span className="status-badge status-incomplete">Incomplete</span>
        )}
      </td>
      <td>
        <span
          className="clickable-date"
          onClick={() => navigateToCashupDetail(cashup._id)}
        >
          {formatDate(cashup.date)}
        </span>
      </td>
      <td>{cashup.cashedUpBy?.name || 'N/A'}</td>
      <td>{cashup.notes || 'N/A'}</td>
      <td>{formatLastEditTime(cashup.lastEditTime)}</td>
    </tr>
  );
};

export default CashupTableRow;